import * as _ from 'lodash';

//  Note that we are intentionally using this Project type (and not the model-typings one), since it includes the associations that we need.
import type { Project } from '../../../../types';

const projectGeneralSettingsFields = [
  'title',
  'url',
  'notes',
  'labels',
  'references',
  'default_branch',
  'tracking_branches',
  'transitive_excludes',
  'vcs_host',
  'integrationhook_timeout',
  'integrationhook_fail_state',
  'public',
  'contributorCount',
  'snippetAutoRejectMatchPercentageThreshold',
] as const;
export type ProjectGeneralSettings = Pick<Project, typeof projectGeneralSettingsFields[number]>;

export const pickGeneralSettingsFromProject = (project: Project): ProjectGeneralSettings =>
  _.pick(project, projectGeneralSettingsFields);

//  For the labels, they are just saved as an array of label IDs, so we convert that here.
export const convertGeneralSettingsToProject = (settings: ProjectGeneralSettings) => ({
  ...settings,
  labels: settings.labels?.map(({ id }) => id),
} as unknown as Partial<Project>);
